<script lang="ts" setup>
import { computed } from 'vue'
import ColoredBadge from '../display/ColoredBadge.vue'
import type { IssueBadgeInfo } from '~/models/appointments'

const props = defineProps<{
  badge: IssueBadgeInfo
}>()

const isTagBadge = computed(() => props.badge.isTag === true)
</script>

<template>
  <ColoredBadge
    :key="props.badge.message"
    v-tooltip="props.badge.tooltip"
    :type="props.badge.type"
    class="mr-2"
    :class="{
      'cursor-pointer': isTagBadge || props.badge.link,
      'hover:opacity-80': isTagBadge,
    }"
  >
    <IssueIcon v-if="props.badge.issueType" :issue="props.badge.issueType" />
    <span v-else>{{ props.badge.message }}</span>
  </ColoredBadge>
</template>
